import icon_deploy from './assets/image/icon_deploy.svg'
import icon_base from './assets/image/icon_base.svg'
import icon_analysis from './assets/image/icon_analysis.svg'
import icon_reorder from './assets/image/icon_reorder.svg'
import icon_operate from './assets/image/icon_operate.svg'
import icon_goods from './assets/image/icon_goods.svg'
import icon_OTB from './assets/image/icon_OTB.svg'
import icon_distribution from './assets/image/icon_distribution.svg'
import icon_deliver from './assets/image/icon_deliver.svg'
import icon_factory from './assets/image/icon_factory.svg'
import icon_shopTask from './assets/image/icon_shopTask.svg'
import icon_stockDeliver from './assets/image/icon_stockDeliver.svg'

export const menuList = [
  {
    text: '首页',
    icon: 'fa fa-home',
    name: 'home',
    path: '/dashboard'
  },
  {
    text: '生产管理',
    // icon: icon_goods,
    children: [
      {
        name: 'goodsList',
        path: '/goods/goodsList',
        text: '商品资料'
      },
      {
        name: 'GroupProperty',
        path: '/RegularData/GroupProperty',
        text: '集团属性管理'
      },
      {
        name: 'GroupCategory',
        path: '/RegularData/GroupCategory',
        text: '集团品类管理'
      },
      {
        name: 'brandRelateCategoryList',
        path: '/brandRelateCategory/brandRelateCategoryList',
        text: '品牌关联品类'
      },
      {
        name: 'categoryList',
        path: '/category/list',
        text: '类目管理'
      },
      {
        name: 'productTagIndex',
        path: '/productTag/productTag',
        text: '商品标签'
      },
      {
        name: 'goodsDeliveryPrice',
        path: '/goodsPrice/goodsDeliveryPrice',
        text: '商品分销价'
      },
      {
        name: 'goodsDeliveryPriceMaintain',
        path: '/goodsPrice/goodsDeliveryPriceMaintain',
        text: '商品分销价维护'
      },
      {
        name: 'goodsPrice',
        path: '/goodsPrice/goodsPrice',
        text: '商品价格'
      },
      {
        name: 'goodsPriceMaintain',
        path: '/goodsPrice/goodsPriceMaintain',
        text: '商品价格维护'
      },
      {
        name: 'operationLog',
        path: '/operationLog',
        text: '操作日志'
      },
      // {
      //   name: 'productTagGroup',
      //   path: '/productTag/tagGroup',
      //   text: '标签管理'
      // }
    ]
  },
  // {
  //   text: '库存查询',
  //   icon: icon_factory,
  //   children: [
  //     {
  //       name: 'realTimeInventory',
  //       path: '/inventory/realTimeInventory',
  //       text: '实时库存'
  //     },
  //     {
  //       name: 'logicInventory',
  //       path: '/inventory/logicInventory',
  //       text: '逻辑库存'
  //     },
  //     {
  //       name: 'historyInventory',
  //       path: '/inventory/historyInventory',
  //       text: '历史库存'
  //     },
  //     {
  //       name: 'inventoryTransaction',
  //       path: '/inventory/inventoryTransaction',
  //       text: '库存流水'
  //     }
  //   ]
  // },
  // {
  //   text: '客户数据',
  //   icon: icon_factory,
  //   children: [
  //     {
  //       name: 'customerInfo',
  //       path: '/customerInfo',
  //       text: '客户信息'
  //     },
  //     {
  //       name: 'customerCredit',
  //       path: '/customerCredit',
  //       text: '客户信贷'
  //     },
  //     {
  //       name: 'customerCreditDetail',
  //       path: '/customerCreditDetail',
  //       text: '客户信用明细'
  //     },
  //     {
  //       name: 'customerDiscount',
  //       path: '/customerDiscount',
  //       text: '客户折扣'
  //     },
  //     {
  //       name: 'customerDiscountMaintain',
  //       path: '/customerDiscountMaintain',
  //       text: '维护折扣'
  //     },

  //   ]
  // },
  // {
  //   text: '订单管理',
  //   icon: icon_factory,
  //   children: [
  //     {
  //       name: 'orderManagement',
  //       path: '/order-management/list',
  //       text: '销售订单'
  //     },
  //     {
  //       name: 'customerOrder',
  //       path: '/customerOrder',
  //       text: '客户订单'
  //     },

  //     {
  //       name: 'rebateOrder',
  //       path: '/rebateOrder',
  //       text: '返利单'
  //     },
  //     {
  //       name: 'channelOrder',
  //       path: '/channelOrder',
  //       text: '渠道订单'
  //     },
  //     {
  //       name: 'purchaseSearch',
  //       path: '/purchaseSearch',
  //       text: '采购查询'
  //     },
  //     {
  //       name: 'channelOrderLogs',
  //       path: '/channelOrderLogs',
  //       text: '渠道订单日志'
  //     },
  //     {
  //       name: 'holdList',
  //       path: '/holdList',
  //       text: '已配未执查询'
  //     }
  //   ]
  // },
  // {
  //   text: '工厂装箱',
  //   icon: icon_factory,
  //   children: [
  //     {
  //       name: 'boxingTaskList',
  //       path: '/factoryPacking/boxingTaskList',
  //       text: '装箱计划'
  //     },
  //     {
  //       name: 'plantInteraction',
  //       path: '/factoryPacking/plantInteraction',
  //       text: '工厂交货查询'
  //     },
  //     {
  //       name: 'encasementResult',
  //       path: '/factoryPacking/encasementResult',
  //       text: '工厂装箱结果'
  //     }
  //   ]
  // },
  // {
  //   text: '总仓分货',
  //   icon: icon_stockDeliver,
  //   children: [
  //     {
  //       name: 'deliveryList',
  //       path: '/deliveryList',
  //       text: '分货任务'
  //     },
  //     {
  //       name: 'deliveryRule',
  //       path: '/delivery/deliveryRule',
  //       text: '分货规则'
  //     },
  //     {
  //       name: 'advanceStockSearch',
  //       path: '/advance-stock-delivery/stockSearch',
  //       text: '预收库存查询'
  //     },
  //     {
  //       name: 'factoryfclStoreGood',
  //       path: '/factoryPacking/fclStoreGood',
  //       text: '装箱单查询'
  //     }
  //   ]
  // },
  // {
  //   text: '店铺头单',
  //   icon: icon_deploy,
  //   children: [
  //     {
  //       name: 'headCalculateList',
  //       path: '/storeHead/headCalculateList',
  //       text: '头单计算'
  //     },
  //     {
  //       name: 'storeHeadRuleList',
  //       path: '/storeHead/ruleList',
  //       text: '头单规则'
  //     },
  //     {
  //       name: 'headTemplateList',
  //       path: '/storeHead/templateList',
  //       text: '头单订量'
  //     },
  //   ]
  // },
  // {
  //   text: '新品配货',
  //   icon: icon_shopTask,
  //   children: [
  //     {
  //       name: 'shopTask',
  //       path: '/productionDistribution/shopTask',
  //       text: '配货任务'
  //     },
  //     {
  //       name: 'distributionRules',
  //       path: '/productionDistribution/distributionRules',
  //       text: '配货规则'
  //     },
  //     {
  //       name: 'firstDistribution',
  //       path: '/productionDistribution/firstDistribution',
  //       text: '店铺配货数'
  //     },
  //     {
  //       name: 'distributionSchedule',
  //       path: '/distributionSchedule',
  //       text: '配货进度'
  //     }
  //   ]
  // },
  // {
  //   text: '商品补调',
  //   icon: icon_operate,
  //   children: [
  //     {
  //       name: 'adjustmentList',
  //       path: '/adjustmentList',
  //       text: '补调任务'
  //     },
  //     {
  //       name: 'stockUpActivity',
  //       path: '/stockUpActivity',
  //       text: '活动备货'
  //     },
  //     {
  //       name: 'supplementaryRuleList',
  //       path: '/supplementary-rule/list',
  //       text: '补调规则'
  //     },
  //     {
  //       name: 'supplementaryStrategyList',
  //       path: '/supplementary-strategy-list/list',
  //       text: '策略'
  //     },
  //     {
  //       name: 'adjustmentDistribution',
  //       path: '/adjustmentDistribution',
  //       text: '配货深度配置'
  //     },
  //     {
  //       name: 'replenishAnalysis',
  //       path: '/replenishAnalysis',
  //       text: '补调结果分析'
  //     }
  //   ]
  // },
  // {
  //   text: '调配管理',
  //   icon: icon_deploy,
  //   children: [
  //     {
  //       name: 'deployManagementDistributionOrderList',
  //       path: '/deployManagement/distributionOrderList',
  //       text: '配货单'
  //     },
  //     {
  //       name: 'deployManagementList',
  //       path: '/deployManagement/list',
  //       text: '旧调配计划'
  //     },
  //     {
  //       name: 'deployOrder',
  //       path: '/deployManage/deployOrder',
  //       text: '调配计划'
  //     },
  //     {
  //       name: 'deployAllocateList',
  //       path: '/deployManage/allocate/list',
  //       text: '调配单'
  //     },
  //     {
  //       name: 'deliveryOrder',
  //       path: '/deployManage/deliveryOrder',
  //       text: '执货单'
  //     },
  //     {
  //       name: 'deployManagementDiffOrderList',
  //       path: '/deployManagement/diffOrderList',
  //       text: '差异单'
  //     },
  //     {
  //       name: 'deployManagementDisposalOrderList',
  //       path: '/deployManagement/disposalOrderList',
  //       text: '处置单'
  //     },
  //     {
  //       name: 'deployManagementInventoryTakingOrderList',
  //       path: '/deployManagement/inventoryTaking',
  //       text: '盘点单'
  //     },
  //     {
  //       name: 'deployManagementOutNotifyOrder',
  //       path: '/deployManagement/outNotifyOrder',
  //       text: '发货通知单'
  //     },
  //     {
  //       name: 'deployManagementInNotifyOrder',
  //       path: '/deployManagement/inNotifyOrder',
  //       text: '收货通知单'
  //     }
  //   ]
  // },
  // {
  //   text: '报表管理',
  //   icon: icon_reorder,
  //   children: [
  //     {
  //       name: 'debitMonitoringConfig',
  //       path: '/reportManagement/debitMonitoringConfig',
  //       text: '借货监控'
  //     },
  //     {
  //       name: 'disposalDebitMonitoringConfig',
  //       path: '/reportManagement/disposalDebitMonitoringConfig',
  //       text: '处置借货监控'
  //     },
  //     {
  //       name: 'allocationMonitorDataList',
  //       path: '/reportManagement/allocationMonitorDataList',
  //       text: '店退执行监控'
  //     },
  //     {
  //       name: 'hongKongOutletInvoice',
  //       path: '/reportManagement/hongKongOutletInvoice',
  //       text: '香港出口发票'
  //     },
  //     {
  //       name: 'depositAdvance',
  //       path: '/reportManagement/depositAdvance',
  //       text: '客户保证金及预付款'
  //     },
  //     {
  //       name: 'clientStatement',
  //       path: '/reportManagement/clientStatement',
  //       text: '客户对账单'
  //     },
  //     {
  //       name: 'clientStatementDetail',
  //       path: '/reportManagement/clientStatementDetail',
  //       text: '客户对账单明细'
  //     },
  //     {
  //       name: 'brandBalance',
  //       path: '/reportManagement/brandBalance',
  //       text: '客户品牌余额'
  //     },
  //     {
  //       name: 'accountsPayable',
  //       path: '/reportManagement/accountsPayable',
  //       text: '应收账款明细'
  //     },
  //     {
  //       name: 'wholesaleInvoice',
  //       path: '/reportManagement/wholesaleInvoice',
  //       text: '批发销售发票'
  //     },
  //     {
  //       name: 'jxcReport',
  //       path: '/reportManagement/jxcReport',
  //       text: '进销存报表'
  //     }
  //   ]
  // },
  // // {
  // //   text: '商品补调',
  // //   icon: 'icon-icon_4',
  // //   children: [
  // //     {
  // //       name: 'supplementaryRuleList',
  // //       path: '/supplementary-rule/list',
  // //       text: '补调规则'
  // //     },
  // //     {
  // //       name: 'adjustmentList',
  // //       path: '/adjustmentList',
  // //       text: '补调任务'
  // //     },
  // //     {
  // //       name: 'adjustmentOrder',
  // //       path: '/adjustmentOrder',
  // //       text: '补调单'
  // //     }
  // //   ]
  // // },
  // {
  //   text: '商品翻单',
  //   icon: icon_reorder,
  //   children: [
  //     {
  //       name: 'productReorderTask',
  //       path: '/productReorderTask',
  //       text: '翻单任务'
  //     },
  //     {
  //       name: 'fivePlusList',
  //       path: '/fiveplus-product-reorder/fivePlusList',
  //       text: '翻单计算'
  //     }
  //   ]
  // },
  // {
  //   text: '商品OTB',
  //   icon: icon_OTB,
  //   children: [
  //     {
  //       name: 'otbReport',
  //       path: '/otbPlanning/otbReport',
  //       text: 'OTB规划'
  //     },
  //     {
  //       name: 'otbList',
  //       path: '/otbPlanning/otbList',
  //       text: 'OTB管控'
  //     }
  //   ]
  // },
  // {
  //   name: 'productList',
  //   path: '/product/list',
  //   icon: 'fa fa-file-text',
  //   text: '商品查询'
  // },
  // {
  //   text: '商品分货',
  //   icon: icon_deliver,
  //   children: [
  //     {
  //       name: 'ArrivalPlan',
  //       path: '/ArrivalPlan',
  //       text: '到货计划'
  //     },
  //     {
  //       name: 'sellingOrder',
  //       path: '/productDeliver/sellingOrder',
  //       text: '销售订单'
  //     },
  //     {
  //       name: 'districtProgress',
  //       path: '/productDistrict/districtProgress',
  //       text: '分货任务'
  //     },
  //     {
  //       name: 'pendingSubmissionResult',
  //       path: '/productDistrict/pendingSubmissionResult',
  //       text: '分货结果待提交'
  //     },
  //     {
  //       name: 'deliverDaily',
  //       path: '/productDeliver/deliverDaily',
  //       text: '分货日志'
  //     }
  //   ]
  // },
  // {
  //   text: '商品配货',
  //   icon: icon_distribution,
  //   children: [
  //        /*{
  //          name:'selectProductNo',
  //          path: '/selectProductNo',
  //          text:'新建任务'
  //        },*/ {
  //       name: 'distributionProgress',
  //       path: '/distributionProgress',
  //       text: '配货进度'
  //     },
  //     {
  //       name: 'distributionTask',
  //       path: '/distributionTask',
  //       text: '配货任务'
  //     },
  //     {
  //       name: 'distributionDaily',
  //       path: '/distributionDaily',
  //       text: '配货结果'
  //     },
  //     {
  //       name: 'shopHeaderVolume',
  //       path: '/shopHeaderVolume',
  //       text: '店铺头单量'
  //     }
  //   ]
  // },
  // {
  //   text: '商品分析',
  //   icon: icon_analysis,
  //   children: [
  //     {
  //       name: 'RawData',
  //       path: '/rawData',
  //       text: 'Raw Data'
  //     },
  //     {
  //       name: 'NinePalaceGrid',
  //       path: '/NinePalaceGrid',
  //       text: '九宫格'
  //     },
  //     {
  //       name: 'BestAndWorst',
  //       path: '/BestAndWorst',
  //       text: 'Best & Worst'
  //     },
  //     {
  //       name: 'fivePlusSaleStatus',
  //       path: '/fiveplus-product-reorder/fivePlusSaleStatus',
  //       text: '畅平滞查询'
  //     }
  //   ]
  // },
  // {
  //   text: '基础设置',
  //   icon: icon_base,
  //   children: [
  //     {
  //       name: 'ProductInformation',
  //       path: '/RegularData/ProductInformation',
  //       text: '商品资料'
  //     },
  //     {
  //       name: 'customerInformation',
  //       path: '/RegularData/customerInformation',
  //       text: '客户资料'
  //     },
  //     {
  //       name: 'StoreInfo',
  //       path: '/StoreInfo',
  //       text: '店铺资料'
  //     },
  //     {
  //       name: 'storeTag',
  //       path: '/basicSetting/storeTag',
  //       text: '店铺标签'
  //     },
  //     {
  //       name: 'receiverInfo',
  //       path: '/receiverInfo',
  //       text: '收货人信息'
  //     },
  //     {
  //       name: 'StoreGroup',
  //       path: '/StoreGroup',
  //       text: '店铺组'
  //     },
  //     {
  //       name: 'stockAddress',
  //       path: '/RegularData/stockAddress',
  //       text: '仓库资料'
  //     },
  //     {
  //       name: 'lowestStock',
  //       path: '/basicSetting/lowestStock',
  //       text: '最低库存数'
  //     },
  //     {
  //       name: 'digestibilityRate',
  //       path: '/basicSetting/digestibilityRate',
  //       text: '计划消化率'
  //     },
  //     {
  //       name: 'SizeType',
  //       path: '/SizeType',
  //       text: '尺码组'
  //     },
  //     {
  //       name: 'SalesRegion',
  //       path: '/SalesRegion',
  //       text: '销售大区'
  //     },
  //     {
  //       name: 'DisplayNum',
  //       path: '/DisplayNum',
  //       text: '中类最低陈列量'
  //     },
  //     {
  //       name: 'SettingDisplayQty',
  //       path: '/SettingDisplayQty',
  //       text: '最低陈列量设置'
  //     },
  //     {
  //       name: 'productOrderLevel',
  //       path: '/productOrderLevel',
  //       text: '商品订货级别'
  //     }
  //   ]
  // }

  // {
  //   name: 'allocationList',
  //   path: '/allocation/list',
  //   icon: 'fa fa-exchange',
  //   text: '商品调拨'
  // },
  // {
  //   name: 'stockManage',
  //   path: '/stockManage',
  //   icon: 'fa fa-file-text',
  //   text: '库存查询'
  // },
  // {
  //   text: '其他配置',
  //   icon: 'icon-icon_2',
  //   children: [
  //     {
  //       name: 'FullsizeRules',
  //       path: '/FullsizeRules',
  //       text: '齐码规则'
  //     },
  //     {
  //       name: 'saleRegular',
  //       path: '/RegularData/saleRegular',
  //       text: '畅平滞规则'
  //     }
  //   ]
  // },
  // {
  //   text: '账户管理',
  //   icon: 'icon-icon_3',
  //   path: '/user/manage',
  //   name: 'userManage'
  // }
]

 //
 // if( process.env.NODE_ENV == 'NO_LOGIN' ){
 //   exportObj.menuList.push({
 //     text: '商品OTB(2期)',
 //     icon: 'icon-icon_',
 //     children: [
 //       {
 //         name: 'otbList',
 //         path: '/otbPlanning/otbList',
 //         text: 'OTB规划'
 //       }
 //     ]
 //   })
 // }

